<template>
    <div>
        <app-filter-panel
            v-for="panel in panels"
            :key="panel.id"
            :value="panel.active"
            :panel-id="panel.id"
            @apply-filters="filters => onApplyFilters(panel.id, filters)"
            @clear-filters="() => onClearFilters(panel.id)"
        />
    </div>
</template>

<script>
export default {
    name: 'AppFilterPanels',
    components: {
        AppFilterPanel: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppFilterPanel'
            )
    },
    computed: {
        panels() {
            return this.$store.getters['filterPanels/panels'];
        }
    },
    methods: {
        onApplyFilters(panelId, filters) {
            this.$root.$emit(`AppFilterPanels/${panelId}/applyFilters`, filters);
        },
        onClearFilters(panelId) {
            this.$root.$emit(`AppFilterPanels/${panelId}/clearFilters`);
        }
    }
};
</script>
